import { ViewConfig } from "@lib/views";
import {
    AMOUNT_COLUMN_SIZE,
    DATE_COLUMN_SIZE,
} from "@design-system/ViewTable/DefaultColumnSizes";
import { HistoryDetailsBaseRow } from "../../cells/historyDetailsBaseRow";
import { HistoryDetailsAmountCell } from "../../cells/HistoryDetailsAmountCell";
import { HistoryDetailsEntityCell } from "../../cells/HistoryDetailsEntityCell";
import { HistoryDetailsExpandCell } from "../../cells/HistoryDetailsExpandCell";
import { JournalEntryVersionDateCell } from "../cells/JournalEntryVersionDateCell";
import { JournalEntryVersionLinesCell } from "../cells/JournalEntryVersionLinesCell";

export interface JournalEntryVersionRow extends HistoryDetailsBaseRow {
    id: string;
    batchKey: string;
    linesCount: number;
    reference: string;
    amount: number;
    originalAmount: number;
}

export enum JournalEntryVersionColumn {
    DATE = "date",
    LINES = "linesCount",
    REFERENCE = "reference",
    AMOUNT = "amount",
    ENTITY = "entity",
    ACTIONS = "actions",
}

export const journalEntryVersionsViewConfig: ViewConfig<
    JournalEntryVersionRow,
    JournalEntryVersionColumn,
    never
> = {
    columns: {
        [JournalEntryVersionColumn.DATE]: {
            accessorKey: "date",
            name: "Time",
            header: "",
            cell: JournalEntryVersionDateCell,
            immutable: true,
            ...DATE_COLUMN_SIZE,
        },
        [JournalEntryVersionColumn.LINES]: {
            accessorKey: "linesCount",
            name: "Lines",
            header: "Lines",
            cell: JournalEntryVersionLinesCell,
            minSize: 60,
            maxSize: 80,
        },
        [JournalEntryVersionColumn.REFERENCE]: {
            accessorKey: "reference",
            name: "Reference",
            header: "Reference",
            minSize: 120,
            maxSize: 200,
        },
        [JournalEntryVersionColumn.AMOUNT]: {
            accessorKey: "amount",
            name: "Amount",
            header: "Amount",
            cell: HistoryDetailsAmountCell,
            ...AMOUNT_COLUMN_SIZE,
        },
        [JournalEntryVersionColumn.ENTITY]: {
            accessorKey: "entity",
            name: "Entity",
            header: "Entity",
            cell: HistoryDetailsEntityCell,
            minSize: 56,
            maxSize: 150,
        },
        [JournalEntryVersionColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: HistoryDetailsExpandCell,
            minSize: 56,
            maxSize: 56,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
